jQuery(document).ready(function ($) {
    'use strict';

    var hash = window.location.hash.substring(1, window.location.hash.length);

    if (window.location.hash) {

        setTimeout(function () {

            if ($('.filter-button').length > 0) {
                $('.filter-button[data-cat*=' + hash + ']').trigger('click');
            }

        }, 300);

    }

    $(document.body).on('click', '.filter-button', function() {

        var items = $(this).closest('.filter').nextAll('.filter-items').first().find('.filter-item');

        if ($(this).hasClass('active')) {

            $('.filter-button').removeClass('active');
            $(items).removeClass('inactive');
            history.replaceState({}, document.title, window.location.href.split('#')[0]);

        } else {
            $('.filter-button').removeClass('active');
            $(this).addClass('active');

            $(items).addClass('inactive');
            window.location.hash = $(this).attr('data-cat');
            $('.filter-item[data-cat*=' + $(this).attr('data-cat') + ']').removeClass('inactive');

            if ($(this).data('cat') == 'visa-alla') {
                history.replaceState({}, document.title, window.location.href.split('#')[0]);
                $(items).removeClass('inactive');
            }
        }

    });

});